import { IGoal } from "@gtmhub/goals/models";
import { IPlanningSession } from "@gtmhub/sessions";
import { IdMap } from "@gtmhub/util";

export interface IGoalsGroupedBySession {
  session: IPlanningSession;
  goals: IGoal[];
}

export function groupGoalsBySession(goal: IGoal, type: "supporting" | "supported"): IGoalsGroupedBySession[] {
  if (!goal.links || !goal.links.spec || !goal.links.spec[type] || !goal.links.expanded) {
    return [];
  }

  const sessions: IdMap<IGoal[]> = {
    // empty string key is added because of goals without session
    "": [],
  };
  const sessionsObj: IdMap<IPlanningSession> = {
    // empty string key is added because of goals without session
    // title is added to display it in single goal view
    "": {
      title: "Session deleted",
    },
  };
  const goals: IdMap<IGoal> = {};
  const compiled: IGoalsGroupedBySession[] = [];

  for (let i = 0; i < goal.links.expanded.sessions.length; i++) {
    sessionsObj[goal.links.expanded.sessions[i].id] = goal.links.expanded.sessions[i];
  }

  for (let i = 0; i < goal.links.expanded.sessions.length; i++) {
    sessions[goal.links.expanded.sessions[i].id] = [];
  }

  for (let i = 0; i < goal.links.expanded.goals.length; i++) {
    goals[goal.links.expanded.goals[i].id] = goal.links.expanded.goals[i];
  }

  for (let i = 0; i < goal.links.spec[type].length; i++) {
    // todo: BUG Goal from a private session supports public objective and shouldn't appear in the spec
    // but it does. Its respective session is not included in the expanded though

    if (typeof goals[goal.links.spec[type][i].id] !== "undefined") {
      sessions[goals[goal.links.spec[type][i].id].sessionId].push(goals[goal.links.spec[type][i].id]);
    }
  }

  angular.forEach(sessions, function (value, key) {
    const el = {
      session: sessionsObj[key],
      goals: value,
    };

    if (value.length > 0) {
      compiled.push(el);
    }
  });

  return compiled;
}
